// @flow

import * as orderDirectionTypes from '../types/order-direction'

export default {
  methods: {
    getDestinationDirection (fieldName: string): string {
      if (this.orderBy !== fieldName) {
        return 'ascending'
      }

      return this.orderDirection === orderDirectionTypes.ORDER_DIRECTION_DESC ? 'ascending' : 'descending'
    },
    getRowHeaderSortingClass (fieldName: string): string {
      if (this.orderBy !== fieldName) {
        return 'sorting'
      }

      return `sorting_${this.orderDirection.toLowerCase()}`
    },
    handleColumnHeaderClick (fieldName: string): void {
      let ordering = {orderBy: fieldName, orderDirection: null}

      if (this.orderBy === fieldName) {
        ordering.orderDirection = this.orderDirection === orderDirectionTypes.ORDER_DIRECTION_ASC
          ? orderDirectionTypes.ORDER_DIRECTION_DESC
          : orderDirectionTypes.ORDER_DIRECTION_ASC
      } else {
        ordering.orderDirection = orderDirectionTypes.ORDER_DIRECTION_ASC
      }

      this.$emit('orderingChanged', ordering)
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/sorting.js